import type * as SchemaTypes from '../../../../apolloClient.types';

import type { IpptAssessmentResultFragment, IpptResultDataFragment } from '../Create/CreatePerformanceIpptResults.api';
import { gql } from '@apollo/client';
import { IpptAssessmentResultFragmentDoc, IpptResultDataFragmentDoc } from '../Create/CreatePerformanceIpptResults.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdatePerformanceIpptResultsMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateIpptResultInput;
}>;


export type UpdatePerformanceIpptResultsMutation = (
  { __typename: 'Mutation' }
  & { updateIpptResult: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateIpptResultSuccessfulResponse' }
    & { result: (
      { __typename: 'PerformanceResult' }
      & IpptAssessmentResultFragment
    ) }
  ) }
);


export const UpdatePerformanceIpptResultsDocument = /*#__PURE__*/ gql`
    mutation UpdatePerformanceIpptResults($id: ObjectID!, $input: UpdateIpptResultInput!) {
  updateIpptResult(id: $id, input: $input) {
    ... on UpdateIpptResultSuccessfulResponse {
      result {
        ...IpptAssessmentResult
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${IpptAssessmentResultFragmentDoc}
${IpptResultDataFragmentDoc}`;
export type UpdatePerformanceIpptResultsMutationFn = Apollo.MutationFunction<UpdatePerformanceIpptResultsMutation, UpdatePerformanceIpptResultsMutationVariables>;

/**
 * __useUpdatePerformanceIpptResultsMutation__
 *
 * To run a mutation, you first call `useUpdatePerformanceIpptResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePerformanceIpptResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePerformanceIpptResultsMutation, { data, loading, error }] = useUpdatePerformanceIpptResultsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePerformanceIpptResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePerformanceIpptResultsMutation, UpdatePerformanceIpptResultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePerformanceIpptResultsMutation, UpdatePerformanceIpptResultsMutationVariables>(UpdatePerformanceIpptResultsDocument, options);
      }
export type UpdatePerformanceIpptResultsMutationHookResult = ReturnType<typeof useUpdatePerformanceIpptResultsMutation>;
export type UpdatePerformanceIpptResultsMutationResult = Apollo.MutationResult<UpdatePerformanceIpptResultsMutation>;
export type UpdatePerformanceIpptResultsMutationOptions = Apollo.BaseMutationOptions<UpdatePerformanceIpptResultsMutation, UpdatePerformanceIpptResultsMutationVariables>;